import React, { useEffect, useMemo, useState, useContext } from "react";
import JoditEditor from "jodit-react";
import SideBar from "./SideBar";
import { Dropdown, ProgressBar } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Spinner from "./Spinner";
import { API_BASE_URL, Base_Url } from "../utils/config";
import Viewer from "../Img/user_8777874.png";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { PiListBulletsBold } from "react-icons/pi";
import TopNavBar from "./TopNavBar";
import { FaPlus } from "react-icons/fa";
import bulletCircle from "../assets/bullet-circle.png";
import bulletSqr from "../assets/bullet-sqr.png";
import bulletDot from "../assets/bullet-dot.png";
import { MdUpload } from "react-icons/md";
import PublishImg from "../Img/publish.png";
import DraftImg from "../Img/draft.png";
import CancleImg from "../Img/cancel.png";
import FeatureImg from "../Img/add featured image.png";
import NewTopNavBar from "./NewTopNavBar";
import Select from "react-select";
import GlobalContext from "../context/GlobalContext";

import "../App.css";
// import { parser } from "mammoth/mammoth.browser";
const Editor = ({
  value,
  onChange,
  close,
  onSubmit,
  titleChange,
  title,
  heading,
}) => {
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [contentView, setContentView] = useState("");
  const [availableSpace, setAvailableSpace] = useState(0);
  const [usedSpace, setUsedSpace] = useState(0);
  const [isWaiting, setIsWaiting] = useState(false);
  const [postData, setPostData] = useState({
    title: "",
    content: "",
    categories: [],
    status: "",
    meta: {
      image_url_key: "",
    },
    // featured_media: ''
  });

  const { notificationCount, setNotificationCount } = useContext(GlobalContext);
  const [TotalSpace, setTotalSpace] = useState(0);
  const [meta, setMeta] = useState(undefined);
  const [categories, setCategories] = useState([]);
  const [collaps, setCollaps] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [apiResponse, setApiRespose] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [catAndSubCat, setCatAndSubCat] = useState([]);
  const [mainCategory, setMainCategory] = useState(undefined);
  const [subCategory, setSubCategory] = useState(undefined);
  const [subCatdrop, setSubCatdrop] = useState(undefined);
  const [featuredImgUploading, setFeaturedImgUploading] = useState(false);
  const [mediaId, setMediaId] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [selectedTagOption, setSelectedTagOption] = useState(null);
  const [defaultTagList, setDefaultTagList] = useState([]);
  let loadTagJson = false;
  const apiEndpoint = `${API_BASE_URL}/wp-json/wp/v2/posts`;
  let bearerToken = localStorage.getItem("jwt_token");
  const config1 = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  //
  useEffect(() => {
    if (!bearerToken) {
      navigate("/");
    } else {
      let sessionId = sessionStorage.getItem("sessionId");
      if (!sessionId) {
        let sessionId = Math.floor(Math.random() * 100000);
        sessionStorage.setItem("sessionId", sessionId);
        navigate("/all-articles");
      } else {
        // alert("kjfvj")
        const apiUrl = `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`;
        axios
          .get(apiUrl, config1)
          .then((res) => {
            setApiRespose(res.data);
            console.log("res60=", res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  }, []);

  let demoArr = [];
  for (let i = 0; i < apiResponse.length; i++) {
    demoArr.push({
      id: 0,
      Image: "",
      title: "",
      content: [],
    });
  }
  for (let i = 0; i < apiResponse.length; i++) {
    // console.log(apiResponse.slug)
    if (apiResponse[i].parent == 0) {
      demoArr[i].title = apiResponse[i].name;
      demoArr[i].id = apiResponse[i].id;
    }

    for (let j = 0; j < apiResponse.length; j++) {
      if (apiResponse[i].id == apiResponse[j].parent) {
        demoArr[i].content.push({
          parent: apiResponse[j].parent,
          ...apiResponse[j],
        });
        console.log("filterRes=", apiResponse[j]);
      }
    }
  }

  // console.log("demoArr2=", demoArr);

  const filteredArray = demoArr.filter((obj) => obj.id !== 0);
  // setCategoriesData(filteredArray)
  console.log("filteredArray: ", filteredArray);

  const cats = filteredArray.map((element) => {
    let cat = {
      label: element.title,
      value: element.id,
      children: element.content.map((e) => {
        return { label: e.name, id: e.id, value: e.id, parent: e.parent };
      }),
    };
    return cat;
  });

  console.log(cats);

  //get available space api start

  const getAvailableSpace = () => {
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/file-tracking`)
      .then((res) => {
        // alert();
        console.log(
          `givensize= ${parseInt(res.data.given_size)} gb=${
            res.data.total_file_size_gb
          }`
        );
        setIsWaiting(true);

        setAvailableSpace(
          Number(res.data.given_size) - Number(res.data.total_file_size_gb)
        );
        setTotalSpace(Number(res.data.given_size));
        setUsedSpace(Number(res.data.total_file_size_gb));
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getAvailableSpace();
  }, []);

  //get available space api end
  /////////////////////////////////////////////////////////

  const [dropdown, setDropdown] = useState(false);
  const dropdownChange = () => {
    if (dropdown) {
      setDropdown(false);
    } else {
      setDropdown(true);
    }
  };

  const customCatChange = (e) => {
    let Cat = JSON.parse(e.target.value);
    console.log(e.target.checked);
    if (e.target.checked === true) {
      setMainCategory(Cat);
    } else {
      setMainCategory(undefined);
      setSubCategory(undefined);
    }
  };
  const customSubCatChange = (e) => {
    let subCat = JSON.parse(e.target.value);
    console.log(e.target.checked);
    if (e.target.checked === true) {
      setSubCategory(subCat);
      let parent = cats.filter((element) => element.value == subCat.parent);
      setMainCategory(parent[0]);
    } else {
      setSubCategory(undefined);
    }
  };

  const openSubCats = (value) => {
    if (subCatdrop == value) {
      setSubCatdrop(undefined);
    } else {
      setSubCatdrop(value);
    }
  };

  const clickOndisableCategory = (e) => {
    e.stopPropagation();
    toast.error(
      "One category can be selected at a time; deselect the previous choice before selecting a new one",
      { toastId: "category" }
    );
  };

  ///////////////////////////////////////////////////////////////////////////

  //
  const handleChange = (e) => {
    console.log(e.target.value);
    const { name, value } = e.target;
    setPostData({
      ...postData,
      [name]: value,
    });
  };
  // get catagories

  const handleCategorySelect = (categoryId) => {
    console.log("catagoryId=", categoryId);
    setSelectedCategory(categoryId);
    // You can perform additional actions when a category is selected
  };
  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/wp-json/wp/v2/tags`, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("104REs=", res.data);
        setTagsList(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [loadTagJson]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        axios
          .get(`${API_BASE_URL}/wp-json/wp/v2/categories`, config1)
          .then((res) => {
            console.log("allcat=", res.data);
            setCategories(res.data);
          })
          .catch((err) => {
            console.log("err=", err);
          });
        // setCategories(data);
      } catch (error) {
        // Handle error
      }
    };

    fetchCategories();

    let ulTigger = document.querySelectorAll(
      '[data-ref="ul"] .jodit-toolbar-button__trigger'
    );

    ulTigger.forEach((element) => {
      element.style.display = "none";
    });

    let olTigger = document.querySelectorAll(
      '[data-ref="ol"] .jodit-toolbar-button__trigger'
    );

    olTigger.forEach((element) => {
      element.style.display = "none";
    });
  }, []);

  // get catagories

  //
  let catId = [];

  const handleCatagorySelect = (id) => {
    // alert(id)
    if (catAndSubCat.includes(id)) {
      // alert("wislj")
      // If already selected, remove it from the array
      setCatAndSubCat((prevSelected) =>
        prevSelected.filter((categoryId) => categoryId !== id)
      );
    } else {
      // If not selected, add it to the array
      setCatAndSubCat((prevSelected) => [...prevSelected, id]);
    }
    // setCatAndSubCat((prevCatAndSubCat) => {
    //     const newCatAndSubCat = [...prevCatAndSubCat, id];
    //     console.log("catID134=", newCatAndSubCat);
    //     return newCatAndSubCat;
    // });
  };
  // setCatAndSubCat(catId)
  console.log("130CatAndSub=", catAndSubCat);

  //
  function getHTMLContent() {
    return content;
  }
  const submitHandler = (status) => {
    // alert(status)
    let articleData = document.createElement("div");
    console.log("Response.data.content", content);
    articleData.innerHTML = content;

    const pdfElements = articleData.querySelectorAll(".pdf-view");
    console.log("pdfElements :", pdfElements);

    pdfElements.forEach((element, index) => {
      // Remove the base URL from the href attribute
      const oldHref = element.getAttribute("href");
      const baseUrl = API_BASE_URL;
      const newHref = oldHref.replace(baseUrl, "");
      element.setAttribute("href", newHref);
    });

    const sanitizedContent = articleData.innerHTML.toString();
    console.log("sanitizedContent", sanitizedContent);

    // console.log("content=", sanitizedContent);
    console.log("content=", content);
    console.log("mainCat= ", mainCategory);
    console.log("subCat= ", subCategory);
    // return;
    postData.content = sanitizedContent;
    postData.meta = {
      media_ids: mediaId, // Storing media IDs in post meta
    };
    if (status == "draft") {
      postData.status = "draft";
    } else {
      postData.status = "publish";
    }
    if (selectedTagOption === null) {
      toast.error("Please Select One Tag");
      return;
    }
    postData.tags = [selectedTagOption.id];
    if (mainCategory == undefined) {
      toast.error("Please Select One Category");
      return;
    } else if (postData.title == "") {
      toast.error("Please add title");
      return;
    } else if (
      content == "" ||
      content == "<p><br></p>" ||
      content == "<h1></h1>" ||
      content == "<h2></h2>" ||
      content == "<h3></h3>" ||
      content == "<h4></h4>" ||
      content == "<h5></h5>" ||
      content == "<h6></h6>" ||
      content == "<blockquote></blockquote>" ||
      content == "<pre><br></pre>" ||
      content == "<br><br>" ||
      content == "<pre><br><br><br></pre>" ||
      content == "\n"
    ) {
      toast.error("Please add content");
      return;
    } else {
      postData.categories.push(mainCategory.value);
      if (subCategory == undefined) {
      } else {
        postData.categories.push(subCategory.value);
      }
    }

    // postData.categories.push();

    axios
      .post(apiEndpoint, postData, config1)
      .then((response) => {
        toast.success("Article Created Successfully");
        setNotificationCount(notificationCount + 1);

        console.log("line357=", response);
        const postData = {
          post: response.data,
        };
        console.log("line361=", postData);
        if (response.data.status == "publish") {
          axios
            .post(
              `${window.location.origin}/backend_cosmos/refresh/createPost`,
              postData
            )
            .then((res) => {
              console.log("line364=", res);
            })
            .catch((err) => {
              //   toast.error(
              //     "Article created successfully, but AI database not updated."
              //   );
              console.log(err);
            });
        }

        // return;

        navigate("/table-posts");

        // store notification number start

        let notification_count_specific_user = {
          user_id: response.data.author,
          count_value: "",
        };
        let notification_count = {
          user_id: "",
          count_value: notificationCount,
          reflect_count: "all_admin",
        };
        if (notification_count.user_id == "") {
          // post notification on usermeta start
          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
              notification_count,
              config1
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }
        if (notification_count_specific_user.user_id != "") {
          // post notification on usermeta start
          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
              notification_count_specific_user,
              config1
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }
        // store notification number end

        //
        //recomandation data
        let notification_api_data;

        if (response.data.status == "publish") {
          notification_api_data = {
            author: localStorage.getItem("display_name"),
            articles: response.data.title.rendered,
            event_type: "Create New Article",
            article_ids: response.data.id,
            author_ids: localStorage.getItem("current_user_Id"),
            email: localStorage.getItem("userEmail"),
            notification_ids: response.data.author,
          };
        } else if (response.data.status == "draft") {
          notification_api_data = {
            author: localStorage.getItem("display_name"),
            articles: response.data.title.rendered,
            event_type: "Draft Article",
            article_ids: response.data.id,
            email: localStorage.getItem("userEmail"),
            author_ids: localStorage.getItem("current_user_Id"),
            notification_ids: response.data.author,
          };
        }
        axios
          .post(
            `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
            notification_api_data,
            config1
          )
          .then((res) => {
            console.log(res.data);
          })
          .catch((err) => {
            console.log(err);
          });

        // recomandation data
      })
      .catch((error) => {
        console.error("Error creating post:", error);
      });

    console.log(`value=${value} title=${title}  heading=${heading}`);

    // onSubmit()
    // close()
  };

  const changeCollapsState = () => {
    if (collaps) {
      setCollaps(false);
    } else {
      setCollaps(true);
    }
  };
  const gotToArticlePage = (postId) => {
    console.log(postId);
    localStorage.setItem("postId", postId);
    navigate(`/single-article?id=${postId}`);
  };
  const uploadUsers = () => {
    navigate("/create-new-user-form");
  };
  const rolles = localStorage.getItem("roles");
  const logOutBtn = () => {
    localStorage.clear();
    navigate("/");
  };
  const HomeBtn = () => {
    localStorage.removeItem("catagoryId");
    navigate("/all-articles");
  };
  const backBtn = () => {
    navigate("/table-posts");
  };

  ///////////////////////////////
  console.log(`total space= ${TotalSpace} availablespace=${availableSpace}`);
  ///////////////////////////////

  const config = useMemo(
    () => ({
      // imageDefaultWidth: 30,
      readonly: false,
      // saveModeInCookie: false,
      spellcheck: true,
      showXPathInStatusbar: false,
      toolbarAdaptive: false,
      // height: isUploading ? '100vh' : 'auto',
      // height: '70vh',
      toolbar: isUploading ? false : true,
      askBeforePasteHTML: false,
      buttons: [
        // "source",
        // "|",
        "bold",
        // "strikethrough",
        "underline",
        "italic",
        "|",
        "ul",
        "ol",
        "|",
        "outdent",
        "indent",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        {
          name: "image",
          // iconURL: 'https://cdn-icons-png.flaticon.com/512/3820/3820184.png',
        },
        // 'file',
        {
          name: "file",
          iconURL:
            "https://kr.camptratech.com/kr/wp-content/uploads/2023/12/icons8-pdf-100.png",
        },
        // 'video',
        "table",
        "link",
        "|",
        "align",
        "undo",
        "redo",
        "|",
        "hr",
        "eraser",
        "copyformat",
        "|",

        // "fullsize",
        // "print",

        {
          name: "video",
          tooltip: "Insert Video",
          // iconURL: "https://www.iconpacks.net/icons/1/free-video-icon-818-thumb.png",
          // iconURL: "https://kr.camptratech.com/kr/wp-content/uploads/2023/12/play-button_5097043.png",
          popup: (editor, current, self, close) => {
            const InsertVideo = (link, title) => {
              console.log("title :", title);
              if (link && title) {
                const videoIdMatch = link.match(
                  /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
                );

                console.log("videoIdMatch :", videoIdMatch);

                if (videoIdMatch && videoIdMatch[1]) {
                  const videoId = videoIdMatch[1];

                  const embedCode = `<iframe class="video-iframe" width="560" height="315" title="${title}" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen style="margin: 10px 0px;"></iframe> </br>`;
                  editor.selection.insertHTML(embedCode);
                  close();
                } else if (link.includes("vimeo.com")) {
                  let vimeoLink = link.split("/");
                  // console.log("527=", vimeoLink)
                  const embedCode = `<iframe class="video-iframe" width="560" height="315" title="${title}" src="https://player.vimeo.com/video/${
                    vimeoLink[vimeoLink.length - 1]
                  }" frameborder="0" allowfullscreen style="margin: 10px 0px;"></iframe> </br>`;
                  editor.selection.insertHTML(embedCode);
                  close();
                } else if (link.includes("wistia.com")) {
                  let wistiaLink = link.split("/");
                  const embedCode = `<iframe class="video-iframe" src="https://fast.wistia.net/embed/iframe/${
                    wistiaLink[wistiaLink.length - 1]
                  }?seo=true&amp;videoFoam=false" title="${title}" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" scrolling="no"  name="wistia_embed" msallowfullscreen="" width="640px" height="360px" style="margin: 10px 0px;"></iframe></br>`;
                  editor.selection.insertHTML(embedCode);
                  close();
                } else {
                  alert(
                    "Invalid link please enter a valid youtube/vimeo/wistia link "
                  );
                  close();
                }
              } else {
                alert("Please add URL and title");
              }
            };

            let divElement = editor.create.div("insert-video");
            divElement.style = `display:flex; flex-direction:column;`;
            let inputTitle = document.createElement("input");
            inputTitle.setAttribute("placeholder", "Title");
            let inputElement = document.createElement("input");
            inputElement.style = `margin:10px 0;`;
            inputElement.setAttribute("placeholder", "URL");
            let buttonElement = document.createElement("button");
            buttonElement.style = ` background-color: blue; color: #ffff; padding: 2px 10px; border-radius: 3px; border:none`;
            buttonElement.innerText = "Insert Video";
            buttonElement.onclick = () =>
              InsertVideo(inputElement.value, inputTitle.value);
            divElement.appendChild(inputTitle);
            divElement.appendChild(inputElement);
            divElement.appendChild(buttonElement);

            return divElement;
          },
        },
        // {
        //     name: "image",
        //     tooltip: "Insert Featured Image",
        //     popup: (editor, current, self, close) => {
        //         const InsertFeaturedImage = (file) => {

        //             let formData = new FormData()
        //             formData.append("file", file.target.files[0]);

        //             axios.post(`${API_BASE_URL}/wp-json/wp/v2/media`, formData, { headers: { Authorization: `Bearer ${bearerToken}` } })
        //                 .then((response) => {
        //                     toast.success("Image upload Successfully");
        //                     let data = `{'image_url_key': ${response.data.source_url} }`
        //                     setMeta(JSON.parse(data))
        //                     console.log("Image created:", response.data);
        //                 })
        //                 .catch((error) => {
        //                     console.error("Error creating post:", error);
        //                 });

        //             close()
        //             console.log('InsertFeaturedImage :', file.target.files[0])
        //         };

        //         let divElement = editor.create.div("insert-video");
        //         let inputElement = document.createElement("input")
        //         inputElement.type = 'file'
        //         inputElement.style = `display:none`
        //         inputElement.setAttribute('id', 'InsertFeaturedImage')
        //         inputElement.setAttribute('accept', 'image/*')
        //         inputElement.onchange = (e) => InsertFeaturedImage(e);
        //         let buttonElement = document.createElement("label");
        //         buttonElement.innerText = "Upload Image";
        //         buttonElement.style = `margin:2px 10px; background-color: blue; padding: 2px 10px; color: #ffff; border-radius: 3px; cursor: pointer;`
        //         buttonElement.setAttribute('for', 'InsertFeaturedImage')
        //         // buttonElement.onclick =
        //         divElement.appendChild(inputElement);
        //         divElement.appendChild(buttonElement);

        //         return divElement;
        //     },
        // },
        {
          name: "file",
          tooltip: "Upload downloadable file",
          popup: (editor, current, self, close) => {
            const InsertDownloadable = (file) => {
              console.log(file.target.files[0]);
              if (file.target.files[0].size > 150 * 1024 * 1024) {
                toast.error("Maximum upload file size: 150 MB", {
                  toastId: "largeFile",
                });
                setIsUploading(false);
                // setLargeFile(true)
                return 0;
              } else {
                setIsUploading(true);
                let formData = new FormData();
                formData.append("file", file.target.files[0]);
                console.log(
                  `total space= ${TotalSpace} availablespaceInner=${availableSpace}`
                );
                if (availableSpace > 0) {
                  axios
                    .post(`${API_BASE_URL}/wp-json/wp/v2/media`, formData, {
                      headers: {
                        Authorization: `Bearer ${bearerToken}`,
                        "Content-Disposition": `attachment; filename=${file.target.files[0].name}`,
                      },
                    })
                    .then((response) => {
                      toast.success("file upload Successfully");
                      let data = `{'image_url_key': ${response.data.source_url} }`;
                      // setMeta(JSON.parse(data))
                      setMediaId((prevMediaIds) => [
                        ...prevMediaIds,
                        response.data.id,
                      ]);
                      console.log("file created:", response.data);
                      let LinkCode = `<a target="_blank" href="${response.data.source_url}" >${response.data.slug}</a> </br>`;
                      editor.selection.insertHTML(LinkCode);
                      setIsUploading(false);

                      // track file size api call start
                      const fileSize = {
                        file_size: response.data.media_details.filesize,
                      };
                      axios
                        .post(
                          `${API_BASE_URL}/wp-json/custom/v1/track-filesize`,
                          fileSize,
                          {
                            headers: { Authorization: `Bearer ${bearerToken}` },
                          }
                        )
                        .then((response) => {
                          console.log("Response data:", response.data);
                          setIsWaiting(isWaiting ? false : true);
                          setAvailableSpace(
                            Number(response.data.given_size) -
                              Number(response.data.total_file_size_gb)
                          );
                          setTotalSpace(Number(response.data.given_size));
                          setUsedSpace(
                            Number(response.data.total_file_size_gb)
                          );
                        })
                        .catch((error) => {
                          console.log("Error:", error);
                        });

                      // track file size api call end
                    })
                    .catch((error) => {
                      console.error("Error creating post:", error);
                    });
                  // setIsUploading(false)
                  close();
                  console.log("InsertDownloadable :", file.target.files[0]);
                } else {
                  toast.error("Contact the administrator for more space.");
                  setIsUploading(false);
                }
              }
            };

            let divElement = editor.create.div("insert-video");
            let inputElement = document.createElement("input");
            inputElement.type = "file";
            inputElement.style = `display:none`;
            inputElement.setAttribute("id", "InsertDownloadable");
            // inputElement.setAttribute('accept','image/*')
            inputElement.onchange = (e) => InsertDownloadable(e);
            let buttonElement = document.createElement("label");
            buttonElement.innerText = "Upload File";
            buttonElement.style = `margin:2px 10px; background-color: blue; padding: 2px 10px; color: #ffff; border-radius: 3px; cursor: pointer;`;
            buttonElement.setAttribute("for", "InsertDownloadable");
            // buttonElement.onclick =
            divElement.appendChild(inputElement);
            divElement.appendChild(buttonElement);

            return divElement;
          },
        },
      ],
      textIcons: false,
      //

      minHeight: 400,

      enableDragAndDropFileToEditor: true,
      uploader: {
        url: `${API_BASE_URL}/wp-json/wp/v2/media`,
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          // 'Content-Type': 'multipart/form-data'
        },

        prepareData: function (formData) {
          setIsUploading(true);
          let popup = document.querySelector(".jodit-popup__content");
          popup.style.display = "none";
          document.body.style.overflow = "hidden";
          var file = formData.getAll("files[0]")[0];
          formData.delete("files[0]");
          formData.delete("source");
          formData.delete("path");
          formData.append("file", file);

          console.log("formData 22: ", formData);
          return formData;
        },
        buildData: function (formData) {
          let file = formData.getAll("file")[0];
          console.log("file 492:", file);
          if (file.size > 150 * 1024 * 1024) {
            toast.error("Maximum upload file size: 150 MB", {
              toastId: "largeFile",
            });
            setIsUploading(false);
            // setLargeFile(true)
            return 0;
          } else if (
            file.type == "application/pdf" ||
            file.type == "image/jpeg" ||
            file.type == "image/png" ||
            file.type == "image/jpg"
          ) {
            return formData;
          } else {
            let file = formData.getAll("file")[0];
            let type = file.type.split("/");
            console.log("file type :", type);
            if (type[0] == "application" || type[0] == "text") {
              toast.error("Only .pdf  files can be uploaded", {
                toastId: "largeFile",
              });
              setIsUploading(false);
              // setLargeFile(true)
              return false;
            } else if (type[0] == "image") {
              toast.error("Only .jpeg, .jpg, .png files can be uploaded", {
                toastId: "largeFile",
              });
              setIsUploading(false);
              // setLargeFile(true)
              return false;
            } else {
              toast.error(
                "Only .pdf and .jpeg, .jpg, .png files can be uploaded",
                { toastId: "largeFile" }
              );
              setIsUploading(false);
              // setLargeFile(true)
              return false;
            }
          }
        },
        isSuccess: function (resp) {
          console.log("pdfcheck:", resp);
          if (resp) {
            if (resp.id) {
              return resp;
            } else {
              return false;
            }
          }
          // return false
        },
        getMessage: function (res) {
          console.log("pdfcheck3:", res);
          // return false
        },
        error: function (e) {
          console.log("UploaderError:", e);
        },
        process: function (resp) {
          console.log("561=", resp);
          setMediaId((prevMediaIds) => [...prevMediaIds, resp.id]);
          console.log("mediaId=", mediaId);
          if (availableSpace > 0) {
            return {
              file: resp.slug,
              path: resp.guid.raw,
              baseurl: resp.guid.rendered,
              mediaType: resp.media_type,
              fileSize: resp.media_details.filesize,
            };
          } else {
            toast.error("Contact the administrator for more space.");
            setIsUploading(false);
          }
        },
        defaultHandlerSuccess: function (data) {
          // track file size api call start
          const fileSize = { file_size: data.fileSize };

          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/track-filesize`,
              fileSize,
              {
                headers: { Authorization: `Bearer ${bearerToken}` },
              }
            )
            .then((response) => {
              console.log("Response data:", response.data);
              setIsWaiting(isWaiting ? false : true);
              setAvailableSpace(
                Number(response.data.given_size) -
                  Number(response.data.total_file_size_gb)
              );
              setTotalSpace(Number(response.data.given_size));
              setUsedSpace(Number(response.data.total_file_size_gb));
            })
            .catch((error) => {
              console.log("Error:", error);
            });

          // track file size api call end
          // if(data){
          if (data.mediaType === "image") {
            this.selection.insertHTML(
              `<img decoding="async" src="${data.baseurl}" width="300" height="200"><br>`
            );
            setIsUploading(false);
            document.body.style.overflow = "";
          } else {
            this.selection.insertHTML(
              `<a class="pdf-view" target="_blank" href="${data.baseurl}">${data.file}</a> </br>`
            );
          }
          // var i, field = 'files';
          // if (data[field] && data[field].length) {
          //     for (i = 0; i < data[field].length; i += 1) {
          //         this.selection.insertImage(data.baseurl + data[field][i]);
          //     }
          // }
          setIsUploading(false);
          document.body.style.overflow = "";
          // }
        },
      },
    }),
    [isWaiting]
  );

  const outsideClick = () => {
    dropdown && setDropdown(false);
  };

  const uploadFeaturedImg = (e) => {
    setFeaturedImgUploading(true);
    let file = e.target.files[0];
    let formData = new FormData();
    formData.append("file", file);
    if (availableSpace > 0) {
      axios
        .post(`${API_BASE_URL}/wp-json/wp/v2/media`, formData, {
          headers: { Authorization: `Bearer ${bearerToken}` },
        })
        .then((response) => {
          toast.success("Image upload Successfully");
          // let data = `{'image_url_key': ${response.data.source_url} }`

          setPostData({
            ...postData,
            meta: { image_url_key: response.data.source_url },
          });
          setFeaturedImgUploading(false);
          // track file size api call start
          const fileSize = { file_size: response.data.media_details.filesize };
          console.log("filesize=", response.data.media_details.filesize);

          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/track-filesize`,
              fileSize,
              {
                headers: { Authorization: `Bearer ${bearerToken}` },
              }
            )

            .then((response) => {
              console.log("Response data:", response.data);
              setIsWaiting(isWaiting ? false : true);
              setAvailableSpace(
                Number(response.data.given_size) -
                  Number(response.data.total_file_size_gb)
              );
              setTotalSpace(Number(response.data.given_size));
              setUsedSpace(Number(response.data.total_file_size_gb));
            })
            .catch((error) => {
              console.log("Error:", error);
            });

          // track file size api call end
        })
        .catch((error) => {
          setFeaturedImgUploading(false);
          console.error("Error creating post:", error);
        });
    } else {
      toast.error("Contact the administrator for more space.");
      setIsUploading(false);
    }
  };

  return (
    <div>
      <div className="row g-0" onClick={outsideClick}>
        <div
          className="col-12"
          // style={{ width: collaps ? "78%" : "95%" }}
          // className={
          //     collaps ? "column right-column  col-9 " : "column right-column  col-11 "
          // }
        >
          {/*  */}
          {/* /////////////////////////////////////////////////////////// */}
          {isUploading && (
            <div
              className="d-flex justify-content-center align-items-center  position-fixed z-2"
              style={{
                backgroundColor: "#000000bf",
                width: "75%",
                height: "-webkit-fill-available",
              }}
              onClick={() => ""}
            >
              <div className="d-flex flex-column">
                <h3 className="fw-bold text-light my-4">Uploading...</h3>
                <Spinner />
              </div>
            </div>
          )}
          {/* ///////////////////////////////////////////////////////// */}
          <NewTopNavBar />
          <div
            className="p-4  d-flex flex-column "
            style={{ width: "-webkit-fill-available", minHeight: "84vh" }}
          >
            <h4 className="text-center text-light">{heading}</h4>
            <div style={{ width: "93%" }} className="mx-auto">
              {/* catagory */}
              <div className="row">
                <div className="col-5">
                  {/*  */}
                  <div style={{}}>
                    <h5>Storage Space</h5>
                    <div style={{ width: "60%" }}>
                      <ProgressBar
                        now={(usedSpace / TotalSpace) * 100}
                        label={`${Math.min(
                          (usedSpace / TotalSpace) * 100,
                          100
                        ).toFixed(2)}%`}
                      />
                      {/* <ProgressBar
                        now={
                          isNaN(usedSpace) ||
                          isNaN(TotalSpace) ||
                          TotalSpace === 0
                            ? 0
                            : (usedSpace / TotalSpace) * 100
                        }
                        label={`${
                          isNaN(usedSpace) ||
                          isNaN(TotalSpace) ||
                          TotalSpace === 0
                            ? 0
                            : Math.min(
                                (usedSpace / TotalSpace) * 100,
                                100
                              ).toFixed(2)
                        }%`}
                      /> */}
                    </div>
                    <div className="d-flex" style={{ marginTop: "10px" }}>
                      <p className="m-0 ">
                        Total Space: {TotalSpace.toFixed(2)} GB
                      </p>
                      <p className="m-0 px-2">
                        Used Space:
                        {usedSpace > TotalSpace
                          ? TotalSpace
                          : usedSpace.toFixed(2)}{" "}
                        GB
                      </p>
                      <p className="m-0">
                        Available Space:{" "}
                        {usedSpace > TotalSpace ? 0 : availableSpace.toFixed(2)}{" "}
                        GB
                      </p>
                    </div>
                  </div>
                  {/*  */}

                  {/* <h4>
                    Available Space: {availableSpace >= 0 ? availableSpace : 0}
                    GB
                  </h4> */}
                  {/* <span style={{ fontSize: "14px" }}>
                    {}
                    {mainCategory ? mainCategory.label : ""}{" "}
                    {subCategory ? (
                      <span>
                        {" "}
                        {">"} {subCategory.label}{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </span> */}
                </div>
                <div className="col-7">
                  <div className="text-center pb-1">
                    <span style={{ fontSize: "14px" }}>
                      {}
                      {mainCategory ? mainCategory.label : ""}{" "}
                      {subCategory ? (
                        <span>
                          {" "}
                          {">"} {subCategory.label}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-center">
                      {featuredImgUploading ? (
                        <span
                          style={{ height: "20px", width: "20px" }}
                          className="spinner-border text-primary me-2"
                        ></span>
                      ) : (
                        <img
                          decoding="async"
                          className="featured-image me-2"
                          src={
                            postData.meta.image_url_key &&
                            postData.meta.image_url_key
                          }
                          width={50}
                          alt=""
                          srcset=""
                        />
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        id="featured-image"
                        className="d-none"
                        onChange={uploadFeaturedImg}
                      />
                      <label
                        className="me-2"
                        role="button"
                        style={{
                          color: "#fff",
                          padding: "4px 10px",
                          borderRadius: "5px",
                        }}
                        htmlFor="featured-image"
                      >
                        {/* <MdUpload size={20} /> Featured image */}
                        <img
                          htmlFor="featured-image"
                          className=""
                          // height={40}
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Upload Featured Image"
                          role="button"
                          src={FeatureImg}
                          alt=""
                        />
                      </label>
                    </div>
                    <div className="pe-2">
                      <span className="text-danger">*</span> Category:
                    </div>
                    {/* new */}
                    <div className="d-flex flex-column position-relative  ">
                      <div
                        className="p-1 border rounded d-flex justify-content-between px-1"
                        role="button"
                        style={{ Width: "200px" }}
                        onClick={dropdownChange}
                      >
                        <span style={{ padding: "0 10px" }}>
                          Add/Edit category
                        </span>
                        <samp>
                          {dropdown ? <IoIosArrowUp /> : <IoIosArrowDown />}
                        </samp>
                      </div>

                      {dropdown && (
                        <div
                          className="position-absolute z-3 rounded p-3 border "
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            top: "40px",
                            height: "max-content",
                            overflow: "auto",
                            width: "350px",
                            backgroundColor: "#fff",
                            right: "0px",
                          }}
                        >
                          {cats &&
                            cats.map((category) => {
                              let disable =
                                mainCategory === undefined
                                  ? false
                                  : mainCategory.value == category.value
                                  ? false
                                  : true;
                              let checked =
                                mainCategory === undefined
                                  ? false
                                  : mainCategory.value == category.value
                                  ? true
                                  : false;
                              return (
                                <div className="d-flex flex-column align-items-start">
                                  <div
                                    className="d-flex align-items-center"
                                    onClick={
                                      disable
                                        ? clickOndisableCategory
                                        : (e) => e.stopPropagation()
                                    }
                                  >
                                    {
                                      <FaPlus
                                        size={13}
                                        role="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openSubCats(category.value);
                                        }}
                                      />
                                    }
                                    <input
                                      className="mx-1"
                                      onChange={customCatChange}
                                      checked={checked}
                                      disabled={disable}
                                      type="checkbox"
                                      name=""
                                      value={JSON.stringify(category)}
                                      id={category.value}
                                    />
                                    <label
                                      className={` ${checked && "fw-bold"}`}
                                      role="button"
                                      htmlFor={category.value}
                                      onClick={
                                        disable
                                          ? clickOndisableCategory
                                          : (e) => e.stopPropagation()
                                      }
                                    >
                                      {category.label}
                                    </label>
                                  </div>
                                  {category.children.length > 0 &&
                                    category.children.map((subCat) => {
                                      let dis =
                                        mainCategory === undefined
                                          ? false
                                          : mainCategory.value == subCat.parent
                                          ? false
                                          : true;
                                      let disable2 =
                                        subCategory === undefined
                                          ? false
                                          : subCategory.value == subCat.value
                                          ? false
                                          : true;
                                      let checked2 =
                                        subCategory === undefined
                                          ? false
                                          : subCategory.value == subCat.value
                                          ? true
                                          : false;
                                      return (
                                        <div
                                          className={` ${
                                            subCatdrop == category.value
                                              ? "d-flex"
                                              : "d-none"
                                          } flex-column ms-4`}
                                        >
                                          <div
                                            role="button"
                                            className="d-flex"
                                            onClick={
                                              dis
                                                ? clickOndisableCategory
                                                : (e) => e.stopPropagation()
                                            }
                                          >
                                            <input
                                              checked={checked2}
                                              disabled={dis}
                                              onChange={customSubCatChange}
                                              type="checkbox"
                                              value={JSON.stringify(subCat)}
                                              id={subCat.value}
                                              onClick={
                                                disable
                                                  ? clickOndisableCategory
                                                  : (e) => e.stopPropagation()
                                              }
                                            />
                                            <label
                                              className={`ps-1 ${
                                                checked2 && "fw-bold"
                                              }`}
                                              htmlFor={subCat.value}
                                              role="button"
                                              onClick={
                                                dis
                                                  ? clickOndisableCategory
                                                  : () => ""
                                              }
                                            >
                                              {subCat.label}
                                            </label>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                    {/* <select id="categorySelect"
                                    onChange={(e) => handleCategorySelect(e.target.value)}
                                >
                                    <option value="">Select a category</option>
                                    {categories.map((category) => (
                                        <option key={category.id} value={category.id}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select> */}

                    {/* ///////////////////////////////////Tag Dropdown Start//////////////////////////////////////// */}
                    <div className="p-1 pe-2">
                      <span className="text-danger">*</span> Tag:
                    </div>
                    <div className="p-1 pe-2">
                      <Select
                        closeMenuOnSelect={false}
                        className="tagSelectorSingle"
                        isMulti={false}
                        placeholder="Select a Tag"
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.name}
                        options={tagsList}
                        onChange={setSelectedTagOption}
                        defaultValue={defaultTagList}
                      />
                    </div>
                    {/* ///////////////////////////////////Tag Dropdown End//////////////////////////////////////// */}
                  </div>
                </div>
              </div>
              {/* catagory */}

              <div>
                <div>
                  <input
                    name="title"
                    type="text"
                    className="form-control form-control-sm my-2 "
                    placeholder="Enter Title..."
                    value={postData.title}
                    // onChange={(e) => titleChange(e.target.value)}
                    onChange={handleChange}
                  />
                </div>
                <JoditEditor
                  // name='value'

                  value={contentView}
                  // onChange={handleChange}
                  onChange={(e) => setContent(e)}
                  config={config}
                />
              </div>
            </div>
            <div className="container d-flex justify-content-center  p-3">
              <div>
                {/* <button
                                    className="btn  text-light mx-2"
                                    onClick={() => submitHandler("publish")}
                                    style={{ backgroundColor: '#0d6efd' }}
                                >
                                    Publish
                                </button>
                                <button
                                    className="btn  text-light mx-2"
                                    onClick={() => submitHandler("draft")}
                                    style={{ backgroundColor: '#0d6efd' }}
                                >
                                    Draft
                                </button>
                                <button
                                    className="btn text-light mx-2"
                                    onClick={() => navigate("/table-posts")}
                                    style={{ backgroundColor: '#0d6efd' }}
                                >
                                    Cancel
                                </button> */}
                <img
                  className="me-2"
                  // height={48}
                  onClick={() => submitHandler("publish")}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Publish"
                  role="button"
                  src={PublishImg}
                  alt=""
                />
                <img
                  className="mx-2"
                  // height={40}
                  onClick={() => submitHandler("draft")}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Draft"
                  role="button"
                  src={DraftImg}
                  alt=""
                />
                <img
                  className="ms-2"
                  // height={50}
                  onClick={() => navigate("/table-posts")}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Cancel"
                  role="button"
                  src={CancleImg}
                  alt=""
                />
              </div>
              {/* <div>
                                <button className='btn btn-sm btn-danger  mx-2' onClick={() => close()} >close</button>
                            </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editor;
